var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarPlaceholderSmall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 40,
    height: 40,
    rx: 20.25,
    fill: "#F1F3F7",
    stroke: "#F7F9FC",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 16C25 18.2091 23.2091 20 21 20C18.7909 20 17 18.2091 17 16C17 13.7909 18.7909 12 21 12C23.2091 12 25 13.7909 25 16ZM23 16C23 17.1046 22.1046 18 21 18C19.8954 18 19 17.1046 19 16C19 14.8954 19.8954 14 21 14C22.1046 14 23 14.8954 23 16Z",
    fill: "#505B73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4186 26C28.6739 26.6307 28.8511 27.3014 28.9382 28H13.062C13.1491 27.3014 13.3263 26.6307 13.5816 26C14.7684 23.0682 17.6427 21 21.0001 21C24.3575 21 27.2318 23.0682 28.4186 26ZM21.0001 23C23.2204 23 25.1603 24.2069 26.1979 26H15.8024C16.8399 24.2069 18.7799 23 21.0001 23Z",
    fill: "#505B73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarPlaceholderSmall);
export default __webpack_public_path__ + "static/media/Avatar-placeholder-small.e0bad52ee0a062d36fa208271e78fe00.svg";
export { ForwardRef as ReactComponent };